module.exports = __webpack_public_path__ + "media/images/emblems/Cronay-coat_of_arms-a935f064a012fa3d73b4c69e87bc1d26.svg";